import { useState, useEffect, useRef } from 'react';
import Script from 'next/script';
import {
  useCustomerAuth,
  useCustomerLogout,
  useCustomerOrders,
} from '@backpackjs/storefront';
import Link from 'next/link';

export function AccountNav() {
  const { customerInit, customer } = useCustomerAuth();
  const rewardsPopupBtn = useRef(null);
  const { customerLogout } = useCustomerLogout();
  const { orders } = useCustomerOrders({ perPage: 5, page: 1 });

  const getPage = () => {
    if (
      window.location.pathname === '/account' ||
      window.location.pathname === '/pages/order-history'
    ) {
      return 'orders';
    }
    if (window.location.pathname === '/pages/my-profile') {
      return 'profile';
    }
    if (window.location.pathname === '/account/address-book') {
      return 'addresses';
    }
    if (window.location.pathname === '/account/referral') {
      return 'referral';
    }
  };

  useEffect(() => {
    if (customerInit) {
      if (
        typeof yotpoWidgetsContainer !== 'undefined' &&
        typeof yotpoWidgetsContainer?.initWidgets !== 'undefined'
      ) {
        window.yotpoWidgetsContainer.initWidgets();
      }
    }
  }, []);

  return (
    <div className="account-nav">
      <ul className="flex flex-nowrap items-center gap-x-5 overflow-x-auto lg:block lg:overflow-hidden border-b lg:border-b-0 border-grey-4">
        <li className={`${getPage() === 'profile' ? 'border-b-[3px] border-grey-1 lg:border-b-0' : ''}`}>
          <Link href={`${getPage() === 'profile' ? '#' : '/pages/my-profile'}`}>
            <a className={`${getPage() === 'profile' ? 'active' : ''}`}>
              My Profile
            </a>
          </Link>
          {getPage() === 'profile' && (
            <ul className="!pl-4 hidden lg:block">
              <li>
                <a href="/pages/my-profile#rewards" className={`!mb-3`}>
                  Rewards
                </a>
              </li>
              {orders && orders.length > 1 && (
                <li>
                  <a href="/pages/my-profile#products" className={`!mb-3`}>
                    Buy Again
                  </a>
                </li>
              )}
              <li>
                <a href="/pages/my-profile#discover" className={`!mb-3`}>
                  Discover
                </a>
              </li>
            </ul>
          )}
        </li>
        <li className={`${getPage() === 'orders' ? 'border-b-[3px] border-grey-1 lg:border-b-0' : ''}`}>
          <Link href={`${getPage() === 'orders' ? '#' : '/pages/order-history'}`}>
            <a className={`${getPage() === 'orders' ? 'active' : ''}`}>
              Order History
            </a>
          </Link>
        </li>
        <li className={`${getPage() === 'subscriptions' ? 'border-b-[3px] border-grey-1 lg:border-b-0' : ''}`}>
          <Link href="https://shop.briogeohair.com/tools/recurring/get-subscription-access">
            <a>
              Subscriptions
            </a>
          </Link>
        </li>
        <li className={`${getPage() === 'addresses' ? 'border-b-[3px] border-grey-1 lg:border-b-0' : ''}`}>
          <Link
            href={`${
              getPage() === 'addresses' ? '#' : '/account/address-book'
            }`}
          >
            <a className={`${getPage() === 'addresses' ? 'active' : ''}`}>
              Addresses
            </a>
          </Link>
        </li>
        <li className="hidden lg:block">
          <button
            type="button"
            aria-label="Sign out"
            className="text-xs text-grey-1 lg:text-regular underline hover:no-underline whitespace-nowrap"
            onClick={async () => {
              await customerLogout(null, () => {
                console.log('Signed Out');
              });
            }}
          >
            Sign Out
          </button>
        </li>
      </ul>
      {getPage() === 'profile' && (
        <ul className="account-subnav !px-0 !mx-5 flex justify-center lg:hidden !mt-3 bg-grey-9">
          <li>
            <a href="/pages/my-profile#rewards">
              Rewards
            </a>
          </li>
          <li>
            <a href="/pages/my-profile#products">
              Products
            </a>
          </li>
          <li>
            <a href="/pages/my-profile#discover">
              Discover
            </a>
          </li>
        </ul>
      )}
    </div>
  );
}
